import {styled} from '@linaria/react';
import React, {SVGProps, forwardRef} from 'react';
import {Icon as SvgIcon} from 'react-lazy-svg';
import {COLORS} from '../../../constants/colors';
import type {IconName} from './IconName';
import {useSharedIconUrl} from './IconName';

export enum IconSize {
  XXS = 8,
  XSS = 12,
  XS = 16,
  SS = 20,
  S = 24,
  M = 32,
  L = 48,
  XL = 54,
  XXL = 90,
}

export interface IconProps extends SVGProps<SVGSVGElement> {
  asset: IconName;
  size?: keyof typeof IconSize;
  className?: string;
  style?: React.CSSProperties;
}

type SVGIconType = {url: string} & SVGProps<SVGSVGElement>;
const SvgIconWithFill = styled(SvgIcon)<{fill: string} & SVGIconType>`
  display: block;
  flex-grow: 0;
  flex-shrink: 0;
  fill: ${({fill}) => fill};
`;

const SvgIconWithSize = styled(SvgIconWithFill)<{size: string}>`
  width: ${({size}) => size};
  height: ${({size}) => size};
  flex-basis: ${({size}) => size};
`;

export const Icon = forwardRef<SVGSVGElement, IconProps>(function Icon(
  {asset, className, size, fill = COLORS.Black, ...props},
  ref,
) {
  const url = useSharedIconUrl(asset);
  if (!url) {
    return null;
  }

  if (!size) {
    return (
      <SvgIconWithFill
        className={className}
        fill={fill}
        {...props}
        url={url}
        ref={ref}
      />
    );
  }

  return (
    <SvgIconWithSize
      className={className}
      fill={fill}
      size={`${IconSize[size]}px`}
      {...props}
      url={url}
      ref={ref}
    />
  );
});
